import script from "./PosteLivraisonEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PosteLivraisonEditModal.vue?vue&type=script&setup=true&lang=js"

import "./PosteLivraisonEditModal.vue?vue&type=style&index=0&id=72780bf0&lang=scss"

const __exports__ = script;

export default __exports__